import cn from 'classnames';

import Link from 'components/link/Link';

import { ITagLinkList } from 'source/NFR.types';

const TagLinkList: React.FC<ITagLinkList> = ({ tags = [], leftAligned = false }) => (
  <div
    className={cn('tag-link-list', {
      'tag-link-list--left-align': leftAligned
    })}
  >
    {tags?.map(({ link, inactive }, number) => (
      <Link
        className={cn('tag-link-list--tag', {
          '-inactive': inactive
        })}
        key={number}
        theme="tag"
        {...link}
      />
    ))}
  </div>
);

TagLinkList.displayName = 'TagLinkList';

export default TagLinkList;
